// Author Shi Wenlong
// Date 2021-07-08 16:31:15

import * as model from "@/model/sithMes/quality/SithMesQualityToolBorrowRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityToolBorrowRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
        callbackApi: process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesQualityToolBorrowRecord/workflow/complete-feedback',
        processDefinitionKey: "quality_tool_borrow_record",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
